/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSON, FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSON, } from './FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth';
import { FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSON, FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSON, } from './FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId';
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderAuthOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderAuthOptions(value) {
    return true;
}
export function FxIdApplicationPublicDataBuilderAuthOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'VkontakteComOauth': json['VkontakteComOauth'] == null ? undefined : FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSON(json['VkontakteComOauth']),
        'VkontakteComVkId': json['VkontakteComVkId'] == null ? undefined : FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSON(json['VkontakteComVkId']),
    };
}
export function FxIdApplicationPublicDataBuilderAuthOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderAuthOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderAuthOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'VkontakteComOauth': FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSON(value['VkontakteComOauth']),
        'VkontakteComVkId': FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSON(value['VkontakteComVkId']),
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderAuthOptions.js.map